import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-343860dc")

_pushScopeId("data-v-343860dc")
const _hoisted_1 = { class: "order-id" }
const _hoisted_2 = { class: "order-summary" }
const _hoisted_3 = { class: "order-status" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 0,
  class: "overdue"
}
const _hoisted_6 = { class: "customer-status" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Arrived ")
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = {
  key: 0,
  class: "messages"
}
const _hoisted_13 = { key: 0 }
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" New Message ")
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ion_icon = _resolveComponent("ion-icon")
  const _component_action_button = _resolveComponent("action-button")

  return (_openBlock(), _createBlock("tr", null, [
    _createVNode("td", _hoisted_1, [
      _createVNode("strong", {
        class: "order-customer",
        innerHTML: _ctx.customerName
      }, null, 8, ["innerHTML"]),
      _createVNode("div", { innerHTML: _ctx.orderNumberFormatted }, null, 8, ["innerHTML"]),
      (_ctx.order.orderDetails.client_platform)
        ? (_openBlock(), _createBlock("div", {
            key: 0,
            class: "order-platform",
            textContent: _ctx.order.orderDetails.client_platform
          }, null, 8, ["textContent"]))
        : _createCommentVNode("", true)
    ]),
    _createVNode("td", _hoisted_2, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.itemsSummary, (count) => {
        return (_openBlock(), _createBlock("div", { key: count }, [
          _createVNode("strong", null, _toDisplayString(count), 1)
        ]))
      }), 128 /* KEYED_FRAGMENT */))
    ]),
    _createVNode("td", _hoisted_3, [
      _createVNode("strong", {
        textContent: _ctx.orderStatusFormatted,
        class: { ready: _ctx.isReady }
      }, null, 10, ["textContent"]),
      (_ctx.order.pickupTime)
        ? (_openBlock(), _createBlock("div", _hoisted_4, [
            (_ctx.isLate)
              ? (_openBlock(), _createBlock("span", _hoisted_5))
              : _createCommentVNode("", true),
            _createTextVNode(" " + _toDisplayString(_ctx.pickupTimeFormatted), 1 /* TEXT */)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode("td", _hoisted_6, [
      (_ctx.hasArrived)
        ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
            _createVNode("strong", null, [
              _hoisted_7,
              (_ctx.order.orderDetails.acknowledge_arrival)
                ? (_openBlock(), _createBlock(_component_ion_icon, {
                    key: 0,
                    icon: "/assets/icons/checkmark.svg"
                  }))
                : _createCommentVNode("", true)
            ]),
            (_ctx.isCurbside)
              ? (_openBlock(), _createBlock("div", _hoisted_8, _toDisplayString(_ctx.order.orderDetails?.arrival_status?.vehicle?.color) + " " + _toDisplayString(_ctx.order.orderDetails?.arrival_status?.vehicle?.make) + " " + _toDisplayString(_ctx.order.orderDetails?.arrival_status?.vehicle?.type), 1))
              : _createCommentVNode("", true),
            (_ctx.order.orderDetails?.arrival_status?.location)
              ? (_openBlock(), _createBlock("div", _hoisted_9, [
                  (_ctx.isCurbside)
                    ? (_openBlock(), _createBlock("span", _hoisted_10, " Spot #" + _toDisplayString(_ctx.order.orderDetails.arrival_status.location), 1))
                    : (_openBlock(), _createBlock("span", _hoisted_11, " Location: " + _toDisplayString(_ctx.order.orderDetails.arrival_status.location), 1))
                ]))
              : _createCommentVNode("", true),
            (_ctx.order.orderDetails?.arrival_status?.details != 'N/A')
              ? (_openBlock(), _createBlock("div", {
                  key: 2,
                  textContent: _ctx.order.orderDetails?.arrival_status?.details
                }, null, 8, ["textContent"]))
              : _createCommentVNode("", true)
          ], 64 /* STABLE_FRAGMENT */))
        : _createCommentVNode("", true)
    ]),
    (_ctx.configs.featureFlags().showOrderMessages)
      ? (_openBlock(), _createBlock("td", _hoisted_12, [
          (_ctx.hasOrderMessages)
            ? (_openBlock(), _createBlock("div", _hoisted_13, [
                _hoisted_14,
                _createVNode(_component_action_button, { text: "View" })
              ]))
            : _createCommentVNode("", true),
          (_ctx.canConfirmHandoff)
            ? (_openBlock(), _createBlock(_component_action_button, {
                key: 1,
                class: "confirm-handoff",
                id: "confirm-handoff",
                text: "Confirm Handoff",
                checkmark: true,
                onClick: _withModifiers(_ctx.confirmHandoff, ["stop"])
              }, null, 8, ["onClick"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
})